import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CardDesignerMainControlPanel from './CardDesignerMainControlPanel';
import CardDesignerSecondaryControlPanel from './CardDesignerSecondaryControlPanel';
import DesignEditorControls from '../../../DesignEditor/components/DesignEditorControls';
import { CONTROL_SECTION } from '../../helpers';
import { DESIGN_MODES } from '../../constants';
import { FONT_FAMILY } from '../CardDesignerCardElements/CardDesignerCardElementText/helpers';

const propTypes = {
  className: PropTypes.string,
  onCardSettingsUpdate: PropTypes.func.isRequired,
  onCardElementCreate: PropTypes.func.isRequired,
  onCardElementSelect: PropTypes.func.isRequired,
  onCardElementUpdate: PropTypes.func.isRequired,
  onCardElementsUpdate: PropTypes.func.isRequired,
  onCardElementDelete: PropTypes.func.isRequired,
  onElementConfigurationChange: PropTypes.func.isRequired,
  card: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  cardSide: PropTypes.object,
  cardRef: PropTypes.object,
  refetchCard: PropTypes.func,
  elements: PropTypes.array,
  selectedCardElement: PropTypes.object,
  logoElement: PropTypes.shape({
    cardElement: PropTypes.object.isRequired,
    cardElementConfiguration: PropTypes.object.isRequired,
  }),
  backgroundElement: PropTypes.shape({
    cardElement: PropTypes.object.isRequired,
    cardElementConfiguration: PropTypes.object.isRequired,
  }).isRequired,
  foregroundElement: PropTypes.shape({
    cardElement: PropTypes.object.isRequired,
    cardElementConfiguration: PropTypes.object.isRequired,
  }).isRequired,
  designMode: PropTypes.oneOf(Object.values(DESIGN_MODES)).isRequired,
  printPartnerId: PropTypes.string,
  gridEnabled: PropTypes.bool,
  setGridEnabled: PropTypes.func,
  lastUsedFont: PropTypes.oneOf(Object.values(FONT_FAMILY)),
  allowBarCode: PropTypes.bool,
};

const CardDesignerControlPanel = ({
  className,
  onCardSettingsUpdate,
  onCardElementCreate,
  onCardElementSelect,
  onCardElementUpdate,
  onCardElementsUpdate,
  onCardElementDelete,
  onElementConfigurationChange,
  elements,
  selectedCardElement,
  logoElement,
  backgroundElement,
  foregroundElement,
  card,
  cardSide,
  cardRef,
  refetchCard,
  designMode,
  printPartnerId,
  gridEnabled,
  setGridEnabled,
  lastUsedFont,
  allowBarCode,
}) => {
  const classes = classNames({
    [className]: !!className,
    'card-designer-left-control-pane': true,
  });
  const [activeControlSection, setActiveControlSection] = useState(
    designMode === DESIGN_MODES.COLLAGES
      ? CONTROL_SECTION.BACKGROUND
      : CONTROL_SECTION.LAYOUT,
  );

  return (
    <DesignEditorControls className={classes}>
      <CardDesignerMainControlPanel
        onControlSelect={setActiveControlSection}
        activeControlSection={activeControlSection}
        gridEnabled={gridEnabled}
        setGridEnabled={setGridEnabled}
        designMode={designMode}
        allowBarCode={allowBarCode}
      />

      <CardDesignerSecondaryControlPanel
        activeControlSection={activeControlSection}
        onCardSettingsUpdate={onCardSettingsUpdate}
        onCardElementCreate={onCardElementCreate}
        onCardElementSelect={onCardElementSelect}
        onCardElementUpdate={onCardElementUpdate}
        onCardElementsUpdate={onCardElementsUpdate}
        onCardElementDelete={onCardElementDelete}
        onElementConfigurationChange={onElementConfigurationChange}
        elements={elements}
        selectedCardElement={selectedCardElement}
        logoElement={logoElement}
        backgroundElement={backgroundElement}
        foregroundElement={foregroundElement}
        card={card}
        cardSide={cardSide}
        cardRef={cardRef}
        refetchCard={refetchCard}
        designMode={designMode}
        printPartnerId={printPartnerId}
        gridEnabled={gridEnabled}
        setGridEnabled={setGridEnabled}
        lastUsedFont={lastUsedFont}
      />
    </DesignEditorControls>
  );
};

CardDesignerControlPanel.propTypes = propTypes;

export default CardDesignerControlPanel;
